import React from 'react';

function About() {
  const imgSrc = `${process.env.PUBLIC_URL}/assest/img/blog2.jpg`;
  return (
    <section className="section about" id="about">
      <div className="section-container about-container">
        <div className="about-content">
          <p className="eyebrow">ABOUT US</p>
          <h2 className="section-title">We Are BuniHub</h2>
          <p className="section-text">
            Buni Innovation Hub is the first Innovation Space established in Tanzania under the Commission for Science and Technology (COSTECH). Buni is primarily focused on strengthening the innovation ecosystem through coordination and support to the innovation enablers (innovation spaces) and startups. Buni has been a home to over 10000 youth and 20+ innovation spaces that have benefited from the innovation services offered by Buni Hub. Since it started, Buni has swayed the vibrant innovation ecosystem that resulted in the growth of innovation spaces and startup companies in Tanzania.
          </p>
        </div>
        <div className="about-aside">
          <img className="about-image" src={imgSrc} alt="Technology" />
        </div>
      </div>
    </section>
  );
}

export default About;


